import Dexie from 'dexie';

// Legacy key written by getEquipmentByMachineType before it was tenant-scoped:
// 'equipment' + a 24-char ObjectId machine type, and nothing else. The current
// key appends the tenant ('equipment<machineType><tenant>'), so it is 24 chars
// longer and never matches. The sibling equipment caches — equipmentRecords,
// equipmentAllRecords, allEquipmentCalibrationTypes — carry a word after
// 'equipment', not hex, so they don't match either.
const LEGACY_EQUIPMENT_KEY = /^equipment[0-9a-f]{24}$/;

export const db = new Dexie('evora');
db.version(1).stores({
  cache: 'id, date, data',
  lists: 'id, data'
});

// v2 changes no schema. It exists to sweep the orphaned v1 equipment entries,
// which are unreachable under the new key and would otherwise sit in IndexedDB
// until the user happened to log out or switch tenants.
db.version(2).stores({
  cache: 'id, date, data',
  lists: 'id, data'
}).upgrade(async tx => {
  const keys = await tx.table('cache').where('id').startsWith('equipment').primaryKeys();
  const orphans = keys.filter(id => typeof id === 'string' && LEGACY_EQUIPMENT_KEY.test(id));
  if (orphans.length > 0) {
    await tx.table('cache').bulkDelete(orphans);
  }
});
